import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.scss']
})
export class ModalWindowComponent {

  @Input() modalTitle: string;
  @Input() isSaveDisabled?: boolean;

  @Output() save: EventEmitter<void> = new EventEmitter<void>();
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  onSave(): void {
    this.save.emit();
  }

  onClose(): void {
    this.close.emit();
  }

}
